import React from "react";
import { useRemoveTag } from "@planzone/view-models";

import { Props } from "./types";
import styles from "./styles.scss";
import { RemoveIcon } from "./removeIcon";

function Tag({ tag, removable, removableId, project }: Props) {
  const { isRequestPending, removeTag } = useRemoveTag();

  return (
    <div className={styles.tag}>
      <p>{tag.name}</p>
      <div
        className={styles.removeTagIconContainer}
        onClick={() =>
          !isRequestPending &&
          removeTag({
            project,
            removable,
            removableId,
            tag,
          })
        }
      >
        <RemoveIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Tag };
